export default function Bannerzin({ banner, onClick, overlay = true, sponsor = false }: { banner: { [key: string]: any }, onClick: () => void, overlay?: boolean, sponsor?: boolean }) {

    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        onClick();
    }

    const image = overlay ? banner?.imgUrl : banner?.images?.sort((a: { order: number }, b: { order: number }) => a.order - b.order)[0]?.cImgUrl;

    return (
        <div 
            className="w-[240px] flex-none select-none cursor-pointer bg-white group overflow-hidden rounded-2xl border border-primary/5 shadow-sm hover:shadow-2xl hover:shadow-secondary/10 transition-all duration-500 relative z-[3]" 
            onClick={(e) => handleClick(e)}
        >
            <div className="h-[240px] w-full relative overflow-hidden">
                <img 
                    src={image} 
                    alt="banner" 
                    className="object-cover h-full w-full transition-transform duration-700 group-hover:scale-110" 
                />
                
                {
                    sponsor ?
                        <div className="absolute top-3 left-3 bg-secondary/90 backdrop-blur-md text-white font-bold text-[10px] tracking-widest uppercase py-1 px-3 rounded-full shadow-lg">
                            Destaque
                        </div>
                        : null
                }

                {/* Subtle gradient overlay for better image depth */}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>

            <div className="p-4 bg-white transition-colors duration-300 group-hover:bg-moninho">
                <div className="flex flex-col items-center">
                    <p className="text-[10px] tracking-[0.2em] font-medium text-mono uppercase mb-1">
                        {banner?.brand} | {banner?.year}
                    </p>
                    <h3 className="text-sm font-extrabold tracking-wide text-primary text-center line-clamp-1 h-5 mb-2 group-hover:text-secondary transition-colors uppercase">
                        {banner?.model}
                    </h3>
                    
                    <div className="w-8 h-[2px] bg-secondary/30 mb-2 group-hover:w-16 transition-all duration-500" />
                    
                    <p className="text-secondary font-black text-sm tracking-widest">
                        {banner?.price ? `R$ ${banner.price.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}` : "SOB CONSULTA"}
                    </p>
                </div>
            </div>

            {
                overlay ?
                    <div className="absolute inset-0 bg-primary/40 opacity-100 group-hover:opacity-0 transition-opacity duration-500 pointer-events-none" />
                    : null
            }
        </div>
    )
}
